export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID // set your app id here
export const D_O_S_A = process.env.REACT_APP_DIGITAL_OCEAN_SPACE_ACCESS;
export const D_O_S_S = process.env.REACT_APP_DIGITAL_OCEAN_SPACE_SECRET;